<template>
  <div v-show="showWebcamFeatures">
    <button @click="getProduct">Found Product</button>
  </div>
</template>

<script>
  export default {
    name: "TestBarcodeReader",
    props: {
      starScan: Boolean,
    },
    data() {
      return {
        detectedCode: "9787115427892"
      };
    },
    methods: {
      getProduct() {
        console.log("TestBarcodeReader", this.detectedCode);
        this.$emit('barcode-detected', this.detectedCode);
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// EcomCore/Components/InputDevices/TestBarcodeReader.vue